// extracted by css-extract-rspack-plugin
export default {"service":"service-oSa9f3 text-base-semibold","detail":"detail-Pj0szR text-xs-medium"};